import React, { useState, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { observer } from "mobx-react-lite";
import RequireAuth from '../Auth/RequireAuth';
import AuthContext from "../../context/AuthProvider";

import Layout from "../Common/Layout";
import NotFound from "../NotFound";

import TopHeader from "./TopHeader";
import Sidebar from "./Sidebar";
import MainFooter from "./MainFooter";

import Home from "../Home";


import SchedulePlanList from "../StaffPortal/SchedulePlan/List";
import ReplacementScheduleList from "../StaffPortal/SchedulePlan/ReplacementScheduleList";
import SchedulePlanWeekListByPlanId from "../StaffPortal/SchedulePlan/SchedulePlanWeekListByPlanId";
import QRCodeAttendance from "../StaffPortal/SchedulePlan/QRCodeAttendance";
import StudentAttendanceList  from "../StaffPortal/SchedulePlan/StudentAttendanceList";

// Import evaluation components
import EvaluationList from "../StaffPortal/Evaluation/EvaluationList";
import ViewEvaluation from "../StaffPortal/Evaluation/ViewEvaluation";
import EvaluationReport from "../StaffPortal/Evaluation/EvaluationReport";

// Import exam registration components
import ExamRegistration from "../StaffPortal/ExamRegistration/Index";
import GradeManagement from "../StaffPortal/ExamRegistration/GradeManagement";

// Import exam plan components
import ExamPlanList from "../StaffPortal/ExamPlan/Index";

import Profile from '../StaffPortal/Profile/Profile';
import Help from '../Help';
import { ImpersonationBanner } from '../Impersonation';

const MainLayout = () => {
    const { auth } = useContext(AuthContext);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const getRoutes = () => {
        const routes = [
            { path: "/Home", element: <Home />, roles: ["admin"] },
            

            //Faculty

            { path: "/SchedulePlan/List", element: <SchedulePlanList />, roles: ["admin"] },
            { path: "/SchedulePlan/ReplacementScheduleList", element: <ReplacementScheduleList />, roles: ["admin"] },
            { path: "/SchedulePlan/SchedulePlanWeekListByPlanId/:schedulePlanId", element: <SchedulePlanWeekListByPlanId />, roles: ["admin"] },
            { path: "/attendance/qr", element: <QRCodeAttendance />, roles: ["admin"] },
            { path: "/attendance/studentlist", element: <StudentAttendanceList  />, roles: ["admin"] },
            
            // Evaluation routes
            { path: "/Evaluation/List", element: <EvaluationList />, roles: ["admin"] },
            { path: "/Evaluation/View/:id", element: <ViewEvaluation />, roles: ["admin"] },
            { path: "/Evaluation/Report/:templateId", element: <EvaluationReport />, roles: ["admin"] },

            // Exam Registration routes
            { path: "/ExamRegistration/List", element: <ExamRegistration />, roles: ["admin"] },
            { path: "/ExamRegistration/GradeManagement", element: <GradeManagement />, roles: ["admin"] },

            // Exam Plan routes
            { path: "/ExamPlan/List", element: <ExamPlanList />, roles: ["admin"] },

            { path: "/Profile", element: <Profile  />, roles: ["admin"] },
            { path: "/Help", element: <Help  />, roles: ["admin"] },
        ];
        return routes.map(route => (
            <Route key={route.path} exact path={route.path} element={route.element} />
        ));
    };

    return (
        <>
        <ImpersonationBanner />
        <div className="d-flex flex-column min-vh-100 bg-light" style={{ marginTop: auth?.isImpersonating ? '40px' : '0' }}>
            <header className="sticky-top">
                <div className="container-fluid p-0">
                    <TopHeader toggleSidebar={toggleSidebar} />
                </div>
            </header>
            <div className="d-flex flex-grow-1 overflow-hidden">
                <aside className={`col-lg-2 d-lg-block bg-white text-dark border-end shadow-sm sidebar ${isSidebarOpen ? '' : 'd-none'}`} style={{ minHeight: '100%', overflowY: 'auto' }}>
                    <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                </aside>
                <main className="col-lg-10 col-12 p-4 main-content flex-grow-1" style={{ overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route element={<RequireAuth allowedRoles={['Staff']} />}>
                                {getRoutes()}
                            </Route>
                        </Route>
                        <Route exact path="/*" element={<NotFound />} />
                    </Routes>
                </main>
            </div>
            <footer className="mt-auto shadow-sm">
                <div className="container-fluid p-0">
                    <MainFooter />
                </div>
            </footer>
        </div>
        </>
    );
};
export default observer(MainLayout);